import { render } from "./Sonstiges.vue?vue&type=template&id=b8f5f23e"
import script from "./Sonstiges.vue?vue&type=script&lang=js"
export * from "./Sonstiges.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__